import React from "react";
import "./index.css";
import EcoLogo from "../../../../assets/media/ecosystem_logo.png";

export default function NotFound() {
  return (
    <section className="not-found">
      <img src={EcoLogo} alt="brand logo" className="not-found__brand-logo" />
      <h1 className="not-found__header">
        Sorry, we couldn't find the brand or admin type you are looking for.
      </h1>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/components/NotFound/index.js